//#region Date functions
  // For display only (DD.MM.YYYY)
  export function toDE(value: string | null | undefined): string {
    if (!value) return '';
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    // handle already localized input like "DD.MM.YYYY"
    const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value);
    return m ? `${m[1]}.${m[2]}.${m[3]}` : '';
  }

  // For inputs (normalize to YYYY-MM-DD)
  export function toYMD(value: string | null | undefined): string {
    console.log('toYMD input:', value);
    if (!value) return '';
    // Already ISO?
    const iso = /^\d{4}-\d{2}-\d{2}$/.test(value);
    if (iso) return value;

    // Was localized "DD.MM.YYYY"?
    const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    // Try Date parsing (only to read out Y-M-D; avoid storing full RFC strings)
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

